<template>
  <div class="mx-3">
    <strong class="display-1">{{ text }}</strong>
    <v-divider class="mb-1"></v-divider>
    <div class="text-uppercase font-weight-light text-xs-center">{{ value }}</div>
  </div>
</template>

<script>
export default {
  props: {
    text: String,
    value: String
  }
}
</script>
